export function getFitDataLayout(item) {
  var _layouts$;
  if (!item) return {
    layout: {},
    layouts: []
  };
  const layouts = 'layouts' in item ? item.layouts : [];
  let layout = 'layout' in item ? item.layout : ((_layouts$ = layouts[0]) === null || _layouts$ === void 0 ? void 0 : _layouts$.layout) || {};
  if (!Object.keys(layout).length && layouts[0]) {
    layout = layouts[0].layout || {};
  }
  return {
    layout,
    layouts
  };
}
//# sourceMappingURL=fitData.js.map
